import { render, staticRenderFns } from "./TriageModeControl.vue?vue&type=template&id=592c6a6a&"
import script from "./TriageModeControl.vue?vue&type=script&lang=ts&"
export * from "./TriageModeControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('592c6a6a')) {
      api.createRecord('592c6a6a', component.options)
    } else {
      api.reload('592c6a6a', component.options)
    }
    module.hot.accept("./TriageModeControl.vue?vue&type=template&id=592c6a6a&", function () {
      api.rerender('592c6a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/debug/TriageModeControl.vue"
export default component.exports